module.exports = __webpack_public_path__ + "static/media/ETV_ENGLISH_NET.74288345.png";